import ContainedButton from "Components/HomeV2/Buttons/Contained";
import { NumberAnimator } from "Components/HomeV2/Hero";
import BrandsSection from "Components/LeadCare/Brands";
import EbookFormSection from "Components/LeadCare/Ebook";
import FAQAccordion from "Components/LeadCare/Faqs";
import SwiperTestimonialSection from "Components/LeadCare/Testimonials";
import SimpleNavbar from "Components/SimpleNavbar";
import { createRef, useEffect, useState } from "react";

declare global {
  interface Window {
    hbspt: any;
  }
}

const LeadCarePage = () => {
  const [playVideo, setPlayVideo] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const toggleVideoPlay = (value: boolean) => {
    setPlayVideo(value);
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/6045774.js";
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  useEffect(() => {
    if (isFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isFormOpen]);
  useEffect(() => {
    if (!isFormOpen) return;

    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    script.async = true;

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "6045774",
          formId: "11e1eeb1-35d6-4655-95ac-fd12db12cb94",
          region: "na1",
          target: "#hubspotForm",
          onFormSubmitted: function () {
            // Redirect after form submission
            window.location.href = "/thank-you-meeting";
          },
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [isFormOpen]);

  // useEffect(() => {
  //     const script = document.createElement("script");
  //     script.src = "https://js.hsforms.net/forms/v2.js";
  //     script.async = true;

  //     script.onload = () => {
  //         if (window.hbspt) {
  //             window.hbspt.forms.create({
  //                 portalId: "6045774",
  //                 formId: "6d3311b7-f1dd-4ff9-b019-82d3dca1dd42",
  //                 region: "na1",
  //                 target: "#hubspotForm",
  //             });
  //             console.log(window.hbspt);
  //         }
  //     };

  //     document.body.appendChild(script);

  //     return () => {
  //         document.body.removeChild(script);
  //     };
  // }, []);
  const ref = createRef<HTMLDivElement>();

  return (
    <main id="home" className="h-full w-full ">
      {/* <section className="bg-black w-full h-20 border-b border-b-gray-300 border-opacity-20 flex items-center justify-center">
                <img src={require('Assets/logo.png')} alt="Salesmrkt" height={30} width={160} />
            </section> */}

      <section
        style={{ backgroundImage: "url('/bg-gradient-leadcare.png')" }}
        className=" bg-cover bg-no-repeat text-black flex flex-col h-full w-full justify-center items-center "
      >
        <div className="flex flex-col h-full w-full justify-center items-center px-5">
          <div className="text-sm md:text-xl font-bold mb-6 text-center sm:text-left w-fit bg-white/95 mt-16 px-8 py-2 rounded-full ">
            Video Production Companies Above $10k/month
          </div>
          <div className="text-3xl md:text-7xl font-bold mb-8 text-center">
            Book 8-12 New Clients
            <br />
            Every 30 Days{" "}
          </div>
          <div className="text-sm md:text-md mb-3 text-center sm:text-left font-bold">
            Step 1: watch the video below and see how this offer works
          </div>
          <div className="items-center justify-center flex rounded-2xl relative overflow-hidden h-auto mb-5 w-full max-w-[1200px] aspect-video">
            {playVideo ? (
              <iframe
                allowFullScreen
                className="h-full w-full"
                src="https://www.youtube.com/embed/n2rUoGqdzE0?autoplay=1&si=A8S15oTrdI8Q1S9R"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              />
            ) : (
              <>
                <div className="absolute z-[1] bg-black/40 w-full h-full flex items-center justify-center mx-auto my-auto">
                  <div
                    className="max-w-[200px] lg:max-w-[400px] flex items-center justify-center cursor-pointer"
                    onClick={() => toggleVideoPlay(true)}
                  >
                    <ContainedButton size="sm">
                      <div className="flex items-center gap-2">
                        <svg
                          className="md:w-5 md:h-6 w-3 h-3"
                          viewBox="0 0 19 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 20.3646V1.269C0 0.445639 0.898116 -0.0630229 1.60426 0.360401L17.5173 9.90237C18.2032 10.3137 18.2035 11.3076 17.5178 11.7193L1.60474 21.2729C0.898614 21.6969 0 21.1882 0 20.3646Z"
                            fill="black"
                          />
                        </svg>
                        <span className="text-sm md:text-base">Play video</span>
                      </div>
                    </ContainedButton>
                  </div>
                </div>
                <img
                  src={"video-thumbnail.png"}
                  className="w-full h-full object-cover"
                  alt="YouTube video thumbnail"
                />
              </>
            )}
          </div>
          <div className="text-sm md:text-md mb-5 text-center sm:text-left font-bold">
            Step 2: book a free demo of our pay-per-close offer by clicking the
            button below
          </div>
          <button
            // href=" https://calendly.com/salesbox-meet/video-ondemand-services"
            // target="_blank"
            onClick={() => setIsFormOpen(true)}
            className="bg-brand-green text-black flex  mb-5 justify-center items-center text-xl md:text-3xl font-bold lg:h-24 rounded-full px-24 border border-brand-green hover:border-black hover:bg-transparent transition-all duration-200 ease-in-out py-5 whitespace-nowrap"
          >
            Book a Demo
          </button>

          <div className="mb-5 text-center uppercase sm:text-left font-light">
            Pay-per-close offer ending soon
          </div>
          {isFormOpen ? (
            <div className="bg-black/40 fixed top-0  py-10 left-0 w-full h-full flex-col justify-center items-center z-50">
              <div className="bg-white p-3 relative mx-auto  my-auto max-w-[800px] w-full overflow-scroll h-full">
                <div
                  className="hs-form-frame"
                  data-region="na1"
                  data-form-id="11e1eeb1-35d6-4655-95ac-fd12db12cb94"
                  data-portal-id="6045774"
                ></div>
                <button
                  className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                  onClick={() => setIsFormOpen(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ) : null}
        </div>

        <ClientFlowSection />

        <p className="text-center font-semibold bg-white w-full pb-5 text-xl">
          RESULTS
        </p>
        <div className="bg-white pb-5 w-full">
          <div
            className="w-full  max-w-[800px] mx-auto bg-white  flex  lg:flex items-center lg:items-center justify-center gap-4  lg:gap-4 md:px-4 py-b md:pb-9  md:bg-contain relative fit-content"
            ref={ref}
          >
            <div>
              <h2 className=" text-black text-sm md:text-lg font-semibold text-center">
                $<NumberAnimator ref={ref} num={37} />M
              </h2>
              <h4 className=" whitespace-nowrap font-light  text-[2vw] xl:text-sm uppercase text-center tracking-[10%] md:font-medium">
                Client revenue generated
              </h4>
            </div>
            <div className="w-[1px] h-[60px] bg-black hidden sm:block"></div>
            <div>
              <h2 className=" text-black text-sm md:text-lg font-semibold text-center">
                <NumberAnimator ref={ref} num={10} />
                K+
              </h2>
              <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-sm uppercase text-center tracking-[10%] md:font-medium">
                qualified meetings
              </h4>
            </div>
            <div className="w-[1px] h-[60px] bg-black hidden sm:block"></div>
            <div>
              <h2 className=" text-sm md:text-lg text-black font-semibold text-center">
                <NumberAnimator ref={ref} num={180} />+
              </h2>
              <h4 className="text-[2vw] whitespace-nowrap  font-light md:text-lg xl:text-sm uppercase text-center tracking-[10%] md:font-medium ">
                satisfied clients{" "}
              </h4>
            </div>

            <img src="brave-ma.png" className="lg:h-16  h-7 ml-2" />
          </div>
        </div>

        <BrandsSection />
        <EbookFormSection openForm={() => setIsFormOpen(true)} />

        <div
          className="flex  lg:flex-row flex-col justify-center items-center w-full gap-5 lg:gap-0 lg:justify-evenly bg-cover bg-no-repeat"
          style={{ backgroundImage: "url('/no-promise-bg.png')" }}
        >
          <p className="text-[#315279] lg:w-[30%] w-[50%] text-[1.5rem] leading-[1.8rem] mt-10 lg:mt-0 text-center font-semibold lg:text-[3rem] lg:leading-[3.2rem]">
            "No results, no pay" promise
          </p>

          <img src="/advantage-trust.png" className=" hidden lg:block" />
          <img src="/advantage.png" className="w-full block lg:hidden " />
        </div>

        <SimpleNavbar />
      </section>
    </main>
  );
};

export default LeadCarePage;

const ClientFlowSection = () => {
  return (
    <div className="bg-white w-full">
      <div className="flex max-w-[1400px] mx-auto flex-col">
        <section className="flex flex-col lg:flex-row  justify-center items-center lg:items-end gap-8 lg:gap-16 px-2 pt-8 pb-4 lg:px-4 max-w-[1400px] mx-auto overflow-hidden">
          <div className="flex flex-col items-center    w-full relative">
            <div className="w-full relative z-10 flex justify-center items-center  pb-4">
              <img
                src={"/camera-man.png"}
                alt="Hand holding phone with person and camera inside"
                className="block  h-[300px] object-contain"
              />
            </div>

            <div className="w-full min-h-[200px] flex flex-col justify-center   border-2 border-[#C63F3F] rounded-lg bg-white  -mt-8 relative z-20 text-center">
              <h3 className="text-[#C63F3F] text-sm lg:text-2xl font-bold mb-2">
                Inconsistent client flow
              </h3>
              <p className="text-black text-[10px] md:text-sm ">
                With most video companies struggle
              </p>
            </div>
          </div>

          <div className="flex  flex-col items-center w-full relative lg:mt-0">
            <div className="w-full relative z-10 flex justify-center items-center pb-4">
              <img
                src={"shake-hands.png"}
                alt="Hand holding phone with people shaking hands inside"
                className="block h-[350px] object-contain"
              />
            </div>
            <div className="w-full flex flex-col justify-center min-h-[200px] lg:px-8  min border-2 border-[#84CC16] rounded-lg bg-white  -mt-24 relative z-20 text-center">
              <h3 className="text-[#84CC16] text-sm lg:text-2xl  font-bold mb-2">
                We handle your entire sales process.
              </h3>
              <p className="text-gray-700  text-[10px] md:text-sm ">
                From lead generation to delivering opportunities,
                <strong className="text-black font-bold">
                  {" "}
                  so you focus on creating videos
                </strong>{" "}
                while we deliver paying clients.
              </p>
            </div>
          </div>
        </section>
        <SwiperTestimonialSection />
      </div>
    </div>
  );
};
